<template>
  <div v-if="date" class="date-preview">
    <div class="date-preview-content">
      <i class="fa fa-calendar-check-o"></i>
      <span class="date-preview-text">Due: {{ formattedDate }}</span>
    </div>
    <div class="debug-info" v-if="debug">
      <small>Raw date: {{ date.toString() }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePreview',
  props: {
    date: {
      type: Date,
      required: false,
      default: null
    },
    debug: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedDate() {
      if (!this.date) return '';
      
      try {
        // Format date as "Day, Month Date, Year"
        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
        return this.date.toLocaleDateString('en-US', options);
      } catch (error) {
        console.error('Error formatting date:', error, this.date);
        return this.date.toString();
      }
    }
  },
  mounted() {
    console.log('DatePreview mounted with date:', this.date);
  },
  updated() {
    console.log('DatePreview updated with date:', this.date);
  }
}
</script>

<style scoped>
.date-preview {
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #e8f4fc;
  border-radius: 4px;
  padding: 8px 12px;
  display: block;
  border-left: 4px solid #4a90e2;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  max-width: 350px;
}

.date-preview-content {
  display: flex;
  align-items: center;
}

.date-preview-content i {
  color: #4a90e2;
  margin-right: 8px;
  font-size: 1.2em;
}

.date-preview-text {
  font-size: 1em;
  color: #2c3e50;
  font-weight: 500;
}

.debug-info {
  margin-top: 5px;
  font-family: monospace;
  font-size: 0.8em;
  color: #666;
  padding-top: 4px;
  border-top: 1px dashed #ddd;
}
</style> 